import Error500 from '#/pages/Fallback/500'
import NotFound from '#/pages/Fallback/NotFound'
import TooManyAttempts from '#/pages/Fallback/TooManyAttempts'

export const PageBuilderFallback = {
  404: <NotFound />,
  429: <TooManyAttempts />,
  500: <Error500 />,
}
